export const breakpoints = {
  ipad: 760,
  desktop: 1024,
};

export const devices = {
  mobile: `(max-width: ${breakpoints.ipad}px)`,
};
